/* Defining Variable - Start */
  var faq = [...document.querySelectorAll(".easytabs-contents .easytabs-accordion-item")];
  var faq_items = [...document.querySelectorAll(".easytabs-content-item")];
  var faq_content = document.querySelectorAll(".easytabs-content-item .easytabs-content-holder");
  var faq_len = faq.length;
  var scroll_header_height;
  /* Defining Variable - End */
  if(window.innerWidth > 760){
    var desktop_header = [...document.querySelectorAll(".ib-sh-header nav .list-menu")][0];
    scroll_header_height = desktop_header.scrollHeight;
  }
  else{
    var mobile_header = [...document.querySelectorAll(".ib-sh-header")][0];
    scroll_header_height = mobile_header.scrollHeight;
  }
  window.addEventListener('resize', function(params) {
    if(window.innerWidth > 760){
      var desktop_header = [...document.querySelectorAll(".ib-sh-header nav")][0];
      scroll_header_height = desktop_header.scrollHeight;
    }
    else{
      var mobile_header = [...document.querySelectorAll(".ib-sh-header")][0];
      scroll_header_height = mobile_header.scrollHeight;
    }
  });
  faq.forEach(el => el.addEventListener('click', function (e) {
    let index = returnindex(this.parentElement);
    this.nextElementSibling.classList.toggle("faq-cont-show");
      getprevioussiblings(this.nextElementSibling, index);
  }));

  /*  ALL  FUNCTIONS  */
  function returnindex(params) {
    for (let i = 0; i < faq_items.length; i++) {
      if (faq_items[i] == params) return i;
    }
  }
  function  getprevioussiblings(params, index){
    for (let j = index - 1; j >= 0; j--) {
      let items = faq_items[j].children[1].classList.contains("faq-cont-show");
      if(items == true){
         let all_prev_hgt = (index - j - 1) > 1 ?  (index - j - 1)*48 : 0;
        let prevhghtt = faq_items[j].getBoundingClientRect().top;
        if(prevhghtt < 0){
          
          window.scrollBy(0, Math.floor(prevhghtt + all_prev_hgt - (scroll_header_height + 100 )));
        }
      }
    }
    rmv_siblings_cls(params);
  }
  function rmv_siblings_cls(params) {
    faq_content.forEach(function (at_cont) {
      if (at_cont != params) {
        at_cont.classList.remove("faq-cont-show");
      }
    });
  }